import { TIERS } from '../constants'
const { TIER_ONE, TIER_TWO, TIER_THREE, TIER_FOUR, TIER_FIVE, TIER_SIX } = TIERS

const result = {
  [TIER_ONE]: {
    title: 'Hvalen døde!',
    subtitle: '',
    whaleCaption: '',
    description:
      'Hvalen fikk i seg for mye plast og måtte avlives. Prøv igjen, du!'
  },
  [TIER_TWO]: {
    title: 'Du reddet ikke hvalen!',
    subtitle: '',
    whaleCaption: 'Hval gjør du?',
    description:
      'Hvalen fikk i seg plast og ble syk. Skal du klare å redde den må du nok gjøre en større innsats.'
  },
  [TIER_THREE]: {
    title: 'Du reddet ikke hvalen!',
    subtitle: '',
    whaleCaption: 'Hval skjer?!',
    description:
      'Hvalen overlevde, men det er fortsatt mer plast i havet enn hva den har godt av. Håper du har lært noe til neste gang.'
  },
  [TIER_FOUR]: {
    title: 'Du reddet ikke hvalen!',
    subtitle: '',
    whaleCaption: 'Hval skjer?!',
    description:
      'Hvalen overlevde, men det er fortsatt mer plast i havet enn hva den har godt av. Håper du har lært noe til neste gang.'
  },
  [TIER_FIVE]: {
    title: 'Du reddet hvalen!',
    subtitle: '',
    whaleCaption: 'Hvaldig bra!',
    description:
      'Bra innsats! Det er likevel mer plast i havet enn hva den har godt av. Du kan gjøre det enda bedre.'
  },
  [TIER_SIX]: {
    title: 'Du reddet hvalen!',
    subtitle: '',
    whaleCaption: 'Digger deg!',
    description:
      'Takket være deg svømmer den nå rundt i plastfritt vann. Fortsett sånn!'
  }
}

const share = {
  [TIER_ONE]: {
    title: 'Jeg prøvde å redde hvalen fra plastdøden!',
    description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
    image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-one.jpg',
    type: 'article'
  },
  [TIER_TWO]: {
    title: 'Jeg prøvde å redde hvalen fra plastdøden!',
    description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
    image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-two.jpg',
    type: 'article'
  },
  [TIER_THREE]: {
    title: 'Jeg prøvde å redde hvalen fra plastdøden!',
    description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
    image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-three.jpg',
    type: 'article'
  },
  [TIER_FOUR]: {
    title: 'Jeg prøvde å redde hvalen fra plastdøden!',
    description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
    image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-four.jpg',
    type: 'article'
  },
  [TIER_FIVE]: {
    title: 'Jeg reddet nesten hvalen fra plastdøden!',
    description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
    image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-five.jpg',
    type: 'article'
  },
  [TIER_SIX]: {
    title: 'Jeg reddet hvalen fra plastdøden!',
    description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
    image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-six.jpg',
    type: 'article'
  }
}

const caption = {
  correct: 'Riktig!',
  wrong: 'Feil!'
}

const start = {
  titlePartOne: 'Redd',
  titlePartTwo: 'hvalen!',
  description: ['Klarer du å redde hvalen fra plastdøden?'],
  startButton: 'Start'
}

const moreInfo = {
  text: 'Se Planet Plast',
  href: 'https://tv.nrk.no/serie/planet-plast'
}

const byline = {
  title: 'Laget av',
  content: [
    {
      title: 'Digital historieutvikling',
      people: [
        'Mari Grafsrønningen',
        'Kari Anne Gisetstad Andersen',
        'Stian Lund Johansen',
        'Ragnar Aasen Rognstad'
      ]
    },
    {
      title: 'Dokumentar og samfunn',
      people: ['Kent-Amar Eriksen', 'Halvard Jakobsen', 'Kim Jansson']
    },
    {
      title: 'Ansvarlig redaktør',
      people: ['Frank Gander']
    }
  ]
}

export { result, caption, share, start, byline, moreInfo }



// WEBPACK FOOTER //
// ./src/v1/config/text.js